<template>
  <div class="q-pa-md row full-width">
    <div class="col-12 text-right q-mb-md">
      <q-btn
        label="Создать"
        @click="createZone"
      />
    </div>
    <div class="col-12">
      <Table
        table-id="zonesTable"
        :table-config="tableConfig"
        :table-data="zones"
        percentage-width
        @row-click="(val) => openZoneEdit(val)"
        @delete-row="(val) => removeZone(val.id)"
      />
    </div>
  </div>
</template>

<script>
import Table from 'Shared/Table'
/**
 * Компонент вкладку со списком зон магазина
 * @module PageShop/Component/SelectedStore/Zones
 * @requires Images/icon/ic-delete.svg
 * @requires vuex
 * @requires PageShop/module
 */
import DeleteIcon from 'Images/icon/ic-delete.svg'
import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('storeModule/zonesModule')

export default {
  name: 'Zones',
  components: {
    Table
  },
  data: () => ({
    DeleteIcon,
    tableConfig: [
      {
        title: 'Имя зоны',
        field: 'name',
        name: 'name',
        columnWidth: 'width: 45%;'
      },
      {
        title: 'Описание',
        field: 'description',
        name: 'description',
        columnWidth: 'width: 45%;'
      },
      {
        emptyHeader: true,
        title: 'Удаление записи',
        name: 'zoneDelete',
        type: 'delete',
        columnWidth: 'width: 10%;'
      }
    ]
  }),
  computed: {
    ...mapState(['zones'])
  },
  methods: {
    /**
     * Удалить зону
     */
    removeZone(zoneId) {
      this.$emit('remove-zone', zoneId)
    },
    /**
     * Открыть редактирование зоны
     */
    openZoneEdit(zone) {
      this.$emit('edit-zone', zone)
    },
    /**
     * Открыть создание зоны
     */
    createZone() {
      this.$emit('create-zone')
    },
    rowClickHandler(row) {
      this.openZoneEdit(row)
    }
  }
}
</script>

<style lang="scss" scoped>
.zones {
  padding: 30px;

  .zone {
    padding: 15px;
    margin-bottom: 15px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    border: 1px solid rgba(gray, 0.5);

    cursor: pointer;

    .title {
      font-size: 18px;
      font-weight: 600;
    }

    .icon {
      width: 36px;
      height: 36px;

      cursor: pointer;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
